import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    allUsers: [],
    currentUser: null,
    currentError: '',
  },
  getters: {
  },
  mutations: {
    setAllUsers(state, users) {
      state.allUsers = users;
    },
    setUser(state, user) {
      state.currentUser = state.allUsers.find(u => u.email == user.email && u.password == user.password || u.id == user.id);
      if (state.currentUser) {
        state.currentError = '';
        localStorage.fcbUserId = state.currentUser.id;
      } else {
        if (user.email && user.password)
          state.currentError = 'La combinación Usuario/Contraseña introducida no es correcta';
        delete localStorage.fcbUserId;
      }
    }
  },
  actions: {
  },
  modules: {
  }
})
